// import $ from 'expose-loader?exposes=$,jQuery!jquery';

// import axios from 'axios';
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

import Config from './utilities/Config.js';

import Breakpoint from './utilities/Breakpoint.js';

// import Feature from './modules/Feature.js';
// import ImagesLoaded from './modules/ImagesLoaded.js';
import Click from './modules/Click.js';
// import ScrollTo from './modules/ScrollTo.js';
import Obfuscate from './modules/Obfuscate.js';
// import SwiperSlider from './modules/SwiperSlider.js';
import ItemList from './modules/ItemList.js';
// import FixedHeader from './modules/FixedHeader.js';
import LinkTransition from './modules/LinkTransition.js';
import Intro from './modules/Intro.js';
import Products from './modules/Products.js';

Config();
Breakpoint();

const modules = {
  // feature: Feature(),
  // imagesLoaded: ImagesLoaded(),
  click: Click(),
  // scrollTo: ScrollTo(),
  obfuscate: Obfuscate(),
  // swiperSlider: SwiperSlider(),
  itemList: ItemList(),
  // fixedHeader: FixedHeader(),
  linkTransition: LinkTransition(),
  intro: Intro(),
  products: Products(),
};
Object.values(modules).forEach((module) => {
  module.init();
});
